import { useEffect, useMemo } from 'react'

import { useGatewaysStore } from '@common/modules/gateways/stores'
import { useProjectsStore } from '@common/modules/projects/stores'

import { useServiceMapStore } from './service-map.store'
import { buildGatewayNode } from './tree-builders'
import { projectMatchesGatewayFetch } from './utils/projectMatchesGatewayFetch'

/**
 * Derives the service map tree from the current project and gateways (same source as the store).
 * Built synchronously so the dashboard card is not one effect behind the gateways store.
 */
export function useServiceMapTree() {
  const currentProject = useProjectsStore((s) => s.currentProject)
  const gateways = useGatewaysStore((s) => s.gateways)
  const lastFetchedProjectId = useGatewaysStore((s) => s.lastFetchedProjectId)
  const buildTreeFromData = useServiceMapStore((s) => s.buildTreeFromData)

  const tree = useMemo(() => {
    if (!currentProject?.id) {
      return []
    }
    if (!projectMatchesGatewayFetch(currentProject.id, lastFetchedProjectId)) {
      return []
    }
    return gateways.map((gateway) => buildGatewayNode(gateway))
  }, [currentProject, lastFetchedProjectId, gateways])

  useEffect(() => {
    buildTreeFromData(
      currentProject?.id ? currentProject : null,
      projectMatchesGatewayFetch(currentProject?.id, lastFetchedProjectId) ? gateways : null
    )
  }, [buildTreeFromData, currentProject, gateways, lastFetchedProjectId])

  return tree
}
